import React from 'react';
import { bool, string, func, element, oneOfType, arrayOf } from 'prop-types';
import EmptyStateProvider from './EmptyStateProvider';

const EmptyStateWrapper = ({
  isEmpty,
  children,
  type,
  action,
  isMobileView,
  theme,
  move,
  enableErrorRevamp,
}) => {
  return !isEmpty ? (
    children
  ) : (
    <EmptyStateProvider
      type={type}
      action={action}
      isMobileView={isMobileView}
      theme={theme}
      move={move}
      enableErrorRevamp={enableErrorRevamp}
    />
  );
};

EmptyStateWrapper.propTypes = {
  isEmpty: bool,
  children: oneOfType([element, arrayOf(element)]),
  type: string,
  action: func,
  isMobileView: bool,
  theme: string,
  move: bool,
  enableErrorRevamp: bool,
};

export default EmptyStateWrapper;
